<template>
  <div class="tu-wrapper">
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <!-- ══ HEADER BANNER ══ -->
    <div class="tu-header">
      <div class="tu-header__title">
        <v-icon color="#818CF8" class="mr-2" size="24">mdi-account-star-outline</v-icon>
        Top Rescuers Dashboard
      </div>
      <v-btn
        v-if="topcommonsnakes && topcommonsnakes.length > 0"
        outlined
        color="white"
        class="excel-btn"
        @click="getExcel()"
      >
        <v-icon left>mdi-microsoft-excel</v-icon>
        Export Excel
      </v-btn>
    </div>

    <!-- ══ CONTENT ══ -->
    <div class="tu-content pa-6">
      <!-- Filter Card -->
      <v-card class="filter-card pa-6 mb-6 elevation-0">
        <div class="filter-title mb-4">
          <v-icon color="#312E81" size="18" class="mr-2">mdi-filter-variant</v-icon>
          Filter Criteria
        </div>
        
        <!-- Input Grids -->
        <v-row class="ma-0">
          <!-- Select Year -->
          <v-col cols="12" sm="6" md="4" lg="3" class="px-2 py-2">
            <span class="input-field-label">Select Year</span>
            <v-select
              :items="years"
              v-model="selectedYear"
              outlined
              dense
              color="#312E81"
              item-color="primary"
              hide-details
            />
          </v-col>

          <!-- Select Month -->
          <v-col cols="12" sm="6" md="4" lg="3" class="px-2 py-2">
            <span class="input-field-label">Select Month</span>
            <v-select
              :items="months"
              v-model="selectedMonth"
              outlined
              dense
              color="#312E81"
              item-color="primary"
              hide-details
            />
          </v-col>

          <!-- District -->
          <v-col cols="12" sm="6" md="4" lg="3" class="px-2 py-2">
            <span class="input-field-label">Select District</span>
            <v-select
              :items="districts"
              v-model="bigsnakeselect"
              outlined
              dense
              color="#312E81"
              item-color="primary"
              hide-details
            />
          </v-col>
        </v-row>

        <!-- Actions -->
        <v-row class="ma-0 mt-4">
          <v-btn
            color="#312E81"
            class="white--text mr-3 submit-btn"
            depressed
            @click="getData()"
          >
            <v-icon left>mdi-check</v-icon>
            Apply Filters
          </v-btn>
          <v-btn
            outlined
            color="#64748B"
            class="reset-btn"
            @click="reset()"
          >
            <v-icon left>mdi-refresh</v-icon>
            Reset
          </v-btn>
        </v-row>
      </v-card>

      <!-- Table Card -->
      <v-card class="table-card elevation-0" v-if="topcommonsnakes && topcommonsnakes.length > 0">
        <v-simple-table class="modern-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left font-weight-bold grey--text text--darken-3">Rescuer Name</th>
                <th class="text-left font-weight-bold grey--text text--darken-3">Rescuer ID</th>
                <th class="text-left font-weight-bold grey--text text--darken-3">District</th>
                <th class="text-left font-weight-bold grey--text text--darken-3">Phone</th>
                <th class="text-left font-weight-bold grey--text text--darken-3">Email</th>
                <th class="text-center font-weight-bold grey--text text--darken-3">Rescue Count</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in topcommonsnakes"
                :key="index"
                class="table-row"
                style="cursor: pointer;"
                @click="navigateToRescuer(item._id)"
              >
                <td class="font-weight-medium text-slate-800">
                  <v-avatar size="32" color="rgba(49,46,129,0.08)" class="mr-2 font-weight-bold primary--text" style="font-size: 13px;">
                    {{ (item && item.name) ? item.name.charAt(0).toUpperCase() : 'U' }}
                  </v-avatar>
                  <span>{{ (item && item.name) ? item.name : 'Unknown' }}</span>
                </td>
                <td class="grey--text text--darken-2 font-weight-medium">
                  {{ (item && item.rescuerProfile && item.rescuerProfile.rescuerCode) ? item.rescuerProfile.rescuerCode : 'N/A' }}
                </td>
                <td class="grey--text text--darken-2 font-weight-medium">
                  {{ (item && item.rescuerProfile && item.rescuerProfile.district) ? item.rescuerProfile.district : 'N/A' }}
                </td>
                <td class="grey--text text--darken-2 font-weight-medium">
                  {{ (item && item.phone) ? item.phone : 'N/A' }}
                </td>
                <td class="grey--text text--darken-1">
                  {{ (item && item.email) ? item.email : 'N/A' }}
                </td>
                <td class="text-center">
                  <v-chip
                    small
                    color="rgba(49,46,129,0.08)"
                    text-color="#312E81"
                    class="font-weight-bold px-4"
                  >
                    {{ (item && item.count) ? item.count : 0 }}
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <!-- Empty State -->
      <v-card class="empty-state-card pa-12 text-center elevation-0" v-else>
        <v-icon size="64" color="#CBD5E1" class="mb-4">mdi-account-search-outline</v-icon>
        <h3 class="empty-title mb-2">No Data Found</h3>
        <p class="empty-desc grey--text text--darken-1 mb-0">No rescuers matched your filter settings. Please adjust your criteria.</p>
      </v-card>

      <!-- Pagination -->
      <div class="d-flex justify-center mt-6" v-if="topcommonsnakes && topcommonsnakes.length > 0">
        <v-pagination
          v-model="currentPage"
          :length="Pagelength"
          :total-visible="7"
          circle
          color="#312E81"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      currentPage: 1,
      Pagelength: 0,
      count: 20,
      topcommonsnakes: [],
      districts: [
        "All", "Palakkad", "Alappuzha", "Malappuram", "Kannur", "Wayanad",
        "Kozhikode", "Thrissur", "Thiruvananthapuram", "Kottayam", "Idukki",
        "Ernakulam", "Kollam", "Pathanamthitta", "Kasaragod",
      ],
      selectedYear: "All",
      selectedMonth: "",
      years: ["All", 2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015],
      months: [
        { text: "All", value: "" },
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 }
      ],
      bigsnakeselect: "All",
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/operation/top-rescuers/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: this.selectedYear,
          month: this.selectedMonth,
          district: this.bigsnakeselect,
          count: this.count,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.topcommonsnakes = response.data.data;
            this.Pagelength = Math.ceil(response.data.count / this.count);
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    reset() {
      this.selectedYear = "All";
      this.selectedMonth = "";
      this.bigsnakeselect = "All";
      this.getData();
    },
    getExcel() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/operation/top-rescuers/list/download/excel",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        responseType: "blob",
        params: {
          year: this.selectedYear,
          month: this.selectedMonth,
          district: this.bigsnakeselect,
        },
      })
        .then((response) => {
          this.appLoading = false;
          const url = URL.createObjectURL(new Blob([response.data], { type: "application/vnd.ms-excel" }));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "TopRescuers.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    navigateToRescuer(id) {
      if (id) {
        this.$router.push({ path: '/officers/rescuerDashboard/' + id });
      }
    },
  },
};
</script>

<style scoped>
.tu-wrapper {
  background-color: #F8FAFC;
  min-height: 100vh;
}
.tu-header {
  background: linear-gradient(135deg, #1E1B4B 0%, #312E81 55%, #4338CA 100%);
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}
.tu-header__title {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
}
.excel-btn {
  font-family: 'Poppins', sans-serif;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.01em !important;
  border-radius: 8px !important;
  height: 36px !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}
.excel-btn:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.8) !important;
}
.filter-card {
  background: #FFFFFF !important;
  border-radius: 12px !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.02) !important;
}
.filter-title {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #1E293B;
  display: flex;
  align-items: center;
}
.custom-checkbox ::v-deep .v-label {
  font-family: 'Poppins', sans-serif;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #475569 !important;
}
.input-field-label {
  display: block;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748B;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
}
.submit-btn {
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  letter-spacing: 0.01em !important;
}
.reset-btn {
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  letter-spacing: 0.01em !important;
}
.table-card {
  background: #FFFFFF !important;
  border-radius: 12px !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.02) !important;
  overflow: hidden;
}
.modern-table {
  width: 100%;
}
.modern-table th {
  font-family: 'Poppins', sans-serif;
  font-size: 12px !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background-color: #FAFBFA;
  height: 48px !important;
}
.modern-table td {
  font-family: 'Poppins', sans-serif;
  height: 56px !important;
  font-size: 13px !important;
}
.table-row:hover {
  background-color: #F8FAFC !important;
}
.empty-state-card {
  background: #FFFFFF !important;
  border-radius: 12px !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.02) !important;
}
.empty-title {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #334155;
}
.empty-desc {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
}
</style>